<template>
  <div>
    <div class="page-head">
      <div class="title">快速筛选订单</div>
      <div class="tab">
        <el-radio-group v-model="quickSearch" size="small" @change="onTypeChange">
          <el-radio-button :label="0">未打印（{{ countInfo.noPrint }}）</el-radio-button>
          <el-radio-button :label="1">已打印未发货（{{ countInfo.isPrint }}）</el-radio-button>
          <el-radio-button :label="2">已锁定（{{ countInfo.isLock }}）</el-radio-button>
          <el-radio-button :label="3">全部</el-radio-button>
        </el-radio-group>
      </div>
      <div class="action">
        <span v-if="syncCount > 0" class="order-count">已同步：{{ syncCount }}条数据</span>
        <el-button type="primary" size="small" @click="onSync" :loading="syncLoading">同步订单</el-button>
      </div>
    </div>
    <list row-key="id" ref="list" unit="订单" :page="page" :query-params="params" :show-checkbox="showCheckbox"
      :show-query="showQuery" :get-data-func="getDataFunc" :after-get-data-func="setStyle" :toolbar-left="16"
      :toolbar-right="8" custom-class="merge-table">
      <div slot="toolbar">
        <div class="toolbar">
          <el-select v-model="quickCheck" @change="onQuickCheck" style="width: 100px;">
            <el-option label="快捷勾选" :value="0"></el-option>
            <el-option label="全部勾选" :value="1"></el-option>
            <el-option label="取消勾选" :value="2"></el-option>
          </el-select>
          <el-select v-model="temp" style="width: 300px;margin: 0 10px;">
            <el-option v-for="(i, k) in ExpressList" :key="k" :label="i.name + '，剩余单数' + i.number"
              :value="i.id"></el-option>
          </el-select>
          <el-button type="primary" @click="openPrint()">打印快递单</el-button>
          <el-button type="primary" @click="openPrintWithSend()">一键发货</el-button>
          <el-dropdown @command="moreAction" style="margin: 0 10px;">
            <el-button type="primary">
              更多操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="batchEditRemark">批量修改备注</el-dropdown-item>
              <el-dropdown-item command="batchRecycleNumber">批量回收单号</el-dropdown-item>
              <el-dropdown-item command="batchLock">批量锁定</el-dropdown-item>
              <el-dropdown-item command="batchUnlock">批量解锁</el-dropdown-item>
              <el-dropdown-item command="batchConsolidateOrders">批量合并订单</el-dropdown-item>
              <el-dropdown-item command="exportOrders">订单导出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="openSetting">设置</el-button>
          <el-button v-if="isDev" type="primary" @click="onTest">测试</el-button>
          <div class="fullscreen-btn">
            <svg-icon v-if="fullscreen" iconClass="cancelfullscreen" @click="setScreen" />
            <svg-icon v-else iconClass="fullscreen" @click="setScreen" />
          </div>
        </div>
        <div class="toolbar">
          <div class="toolbar-left">
            <span>共查到</span>
            <span class="number">{{ totalOrder }}</span>
            <span>个订单，共</span>
            <span class="number">{{ totalParcel }}</span>
            <span>个包裹</span>
          </div>
          <div class="toolbar-right">
            <div style="display: flex;align-items: center;margin-right: 10px;">
              <div style="font-size: 14px;color: #606266;">订单排序：</div>
              <el-select v-model="snField" style="width: 150px">
                <el-option label="商品名称" value="goodsName"></el-option>
                <el-option label="规格名称" value="goodsSpec"></el-option>
                <el-option label="发货时间" value="lastShipTime"></el-option>
                <el-option label="省份城市" value="province"></el-option>
                <el-option label="付款时间" value="payTime"></el-option>
                <el-option label="商品数量" value="goodsCount"></el-option>
                <el-option label="商品金额" value="goodsPrice"></el-option>
                <el-option label="实付金额" value="payAmount"></el-option>
              </el-select>
            </div>
            <el-button type="primary" @click="onSnUp">升序</el-button>
            <el-button type="primary" @click="onSnDown">降序</el-button>
          </div>
        </div>
      </div>
      <template slot="query">
        <!-- <el-form-item label="店铺名称" label-width="112px">
          <el-select v-model="mallToken" placeholder="请选择">
            <el-option v-for="(i, k) in mallList" :key="k" :label="i.mallName" :value="i.token"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="商品搜索" label-width="112px">
          <el-input v-model="params.goodsFilter" placeholder="请输入商品名称/ID" clearable />
        </el-form-item>
        <el-form-item label="商品类目" label-width="112px">
          <el-select v-model="params.categoryName" filterable placeholder="请选择" clearable>
            <el-option v-for="(i, k) in categories" :key="k" :label="i" :value="i"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规格搜索" label-width="112px">
          <el-input v-model="params.specFilter" placeholder="请输入规格名称/ID" clearable />
        </el-form-item>
        <el-form-item label="交易状态" label-width="112px">
          <el-select v-model="params.orderStatusDesc" placeholder="请选择" clearable>
            <el-option label="等待买家付款" value="等待买家付款"></el-option>
            <el-option label="等待卖家发货" value="等待卖家发货"></el-option>
            <!-- <el-option label="等待物流公司揽件" value="等待物流公司揽件"></el-option> -->
            <!-- <el-option label="等待买家收货" value="等待买家收货"></el-option> -->
            <!-- <el-option label="等待买家签收" value="等待买家签收"></el-option> -->
            <!-- <el-option label="买家已签收" value="买家已签收"></el-option> -->
            <!-- <el-option label="已收货" value="已收货"></el-option> -->
            <!-- <el-option label="交易成功" value="交易成功"></el-option> -->
            <el-option label="交易取消" value="交易取消"></el-option>
            <el-option label="交易终止" value="交易终止"></el-option>
            <!-- <el-option label="已收货待到账" value="已收货待到账"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item label="售后状态" label-width="112px">
          <el-select v-model="params.isRefund" placeholder="请选择" clearable>
            <el-option label="无售后" :value="false"></el-option>
            <el-option label="有售后" :value="true"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注留言" label-width="112px">
          <el-select v-model="params.buyerMemo" placeholder="请选择" clearable>
            <el-option label="无商家备注" :value="0"></el-option>
            <el-option label="有商家备注" :value="1"></el-option>
            <el-option label="有买家备注" :value="2"></el-option>
            <el-option label="无买家备注" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div slot="label">
            <el-select v-model="params.fieldType" style="width: 100px;">
              <el-option label="智能搜索" value="sbSearch"></el-option>
              <el-option label="商品件数" value="goodsCount"></el-option>
              <el-option label="订单号" value="orderSn"></el-option>
              <el-option label="快递单号" value="expressNumber"></el-option>
              <el-option label="商品价格" value="goodsPrice"></el-option>
              <el-option label="实付金额" value="payAmount"></el-option>
              <el-option label="收件人" value="receiverName"></el-option>
              <el-option label="手机号" value="receiverPhone"></el-option>
            </el-select>
          </div>
          <el-input v-model="params.fieldValue" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="退款状态" label-width="112px">
          <el-select v-model="params.hasRefund" placeholder="请选择" clearable>
            <el-option label="有退款" :value="1"></el-option>
            <el-option label="无退款" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地区选择" label-width="112px">
          <address-select v-model="params.area" :placeholder="'请选择地区'" @change="onAddressSelect" />
        </el-form-item>
        <el-form-item label="旗帜选择" label-width="112px">
          <el-select v-model="params.flag" placeholder="请选择" clearable>
            <el-option label="红" value="flag-red">红<i class="el-icon-s-flag flag-red"></i></el-option>
            <el-option label="橙" value="flag-orange">橙<i class="el-icon-s-flag flag-orange"></i></el-option>
            <el-option label="黄" value="flag-yellow">黄<i class="el-icon-s-flag flag-yellow"></i></el-option>
            <el-option label="绿" value="flag-green">绿<i class="el-icon-s-flag flag-green"></i></el-option>
            <el-option label="蓝" value="flag-blue">蓝<i class="el-icon-s-flag flag-blue"></i></el-option>
            <el-option label="靛" value="flag-indigo">靛<i class="el-icon-s-flag flag-indigo"></i></el-option>
            <el-option label="紫" value="flag-purple">紫<i class="el-icon-s-flag flag-purple"></i></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="快递公司" label-width="112px">
          <el-select v-model="params.expressName" placeholder="请选择" clearable>
            <el-option v-for="(i, k) in companiesList" :key="k" :label="i.logisticsCompany" :value="i.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间类型" label-width="112px">
          <div class="time-type">
            <el-select v-model="params.timeType">
              <!-- <el-option label="成团时间" value="成团时间"></el-option> -->
              <el-option label="下单时间" value="createTime"></el-option>
              <el-option label="发货时间" value="lastShipTime"></el-option>
              <!-- <el-option label="剩余时间" value="shippingTime"></el-option> -->
            </el-select>
            <range-picker :date="[params.startDate, params.endDate]"
              @change="x => { params.startDate = x.Start; params.endDate = x.End; }" />
          </div>
        </el-form-item>
      </template>
      <template slot="table">
        <!-- <el-table-column label="收件信息" min-width="280px">
          <div slot-scope="{row}" class="merge-item">
            <div>
              <template v-if="row.state == 0 && row.multiorder.length == 1 && row.same">
                <div class="badge badge-nomerge">待合</div>
              </template>
<template v-if="row.multiorder.length > 1">
                <div class="badge badge-merge">合单{{ row.multiorder.length }}</div>
              </template>
<template v-if="row.state != 0 && row.logistics.length > 0">
                <template v-if="row.logistics.length > 1 || row.logistics[0].noList.length > 1">
                  <div class="badge badge-multiple-pack">多包</div>
                </template>
</template>
<span>{{ row.receiverName }}
  <template v-if="dataMasking && row.receiverName != row.decryptData.fullName">
                  <svg-icon class="lock-btn" iconClass="lock" @click="setUnlock(row, 'fullName')" />
                </template>
</span>
<span>，<span v-html="row.receiverPhone"></span>
  <template v-if="dataMasking && row.receiverPhone != row.decryptData.mobilePhone">
                  <svg-icon class="lock-btn" iconClass="lock" @click="setUnlock(row, 'mobilePhone')" />
                </template>
</span>
</div>
<div>
  <span>{{ row.address1 }}</span>
  <span>{{ row.address }}
    <template v-if="dataMasking && row.address != row.decryptData.address">
                  <svg-icon class="lock-btn" iconClass="lock" @click="setUnlock(row, 'address')" />
                </template>
  </span>
</div>
</div>
</el-table-column>
<el-table-column label="合计" min-width="130px">
  <div slot-scope="{row}" class="merge-item">
    <div>
      <span>总数量：</span>
      <span>{{ row.goodsCount }}</span>
    </div>
    <div>
      <span>总价：</span>
      <span>{{ row.goodsPrice }}</span>
    </div>
    <div>
      <span>实收：</span>
      <span>{{ row.payAmount }}</span>
    </div>
  </div>
</el-table-column> -->
        <!-- <el-table-column label="商品信息" min-width="500px">
          <template slot-scope="{row}">
            <div v-for="(order, key) in row.multiorder" :key="key" :id="'order_' + order.id" class="merge-item"
              :class="{ 'goods-merge': row.multiorder.length > 1 }" style="padding: 0;">
              <div class="split-btn" v-if="row.multiorder.length > 1">
                <span title="拆分显示"><svg-icon iconClass="split" @click="onSplitOrder(order)" /></span>
              </div>
              <div v-for="(i, k) in order.items" :key="k" class="merge-item goods-info"
                :class="{ 'merge': order.items.length > 1 }">
                <div class="item-image">
                  <el-image v-if="i.goodsImageUrl" :src="i.goodsImageUrl" fit="contain">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </div>
                <div class="item-info">
                  <div class="ellipsis" :title="i.goodsName">{{ i.goodsName }}</div>
                  <div style="color: #9d9d9d"><span>规格：</span><span>{{ i.goodsSpec }}</span></div>
                  <div style="color: #9d9d9d"><span>数量：</span><span>{{ i.goodsCount }}</span></div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="订单时间" min-width="240px">
          <template slot-scope="{row}">
            <div class="merge-item info-center" v-for="(order, key) in row.multiorder" :key="key"
              :id="'time_' + order.id">
              <div><span>发货剩余：</span><count-down v-model="order.additional.latestDeliveryOn" /></div>
              <div><span>成团时间：</span><span>{{ order.Field4_2 }}</span></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="state" label="状态" width="70px" align="center">
          <div slot-scope="{row}" class="merge-item">
            <span v-if="row.state == 0">未打印</span>
            <span v-if="row.state == 1">已打印</span>
            <span v-if="row.state == 2">已锁定</span>
            <span v-if="row.state == 3">已发货</span>
          </div>
        </el-table-column>
        <el-table-column label="备注/旗帜" min-width="280px">
          <template slot-scope="{row}">
            <div class="merge-item info-center" v-for="(order, key) in row.multiorder" :key="key"
              :id="'remark_' + order.id">
              <div v-if="order.Field6_1 == 0"><i class="el-icon-s-flag flag-red"></i></div>
              <div v-if="order.Field6_1 == 1"><i class="el-icon-s-flag flag-orange"></i></div>
              <div v-if="order.Field6_1 == 2"><i class="el-icon-s-flag flag-yellow"></i></div>
              <div v-if="order.Field6_1 == 3"><i class="el-icon-s-flag flag-green"></i></div>
              <div v-if="order.Field6_1 == 4"><i class="el-icon-s-flag flag-blue"></i></div>
              <div v-if="order.Field6_1 == 5"><i class="el-icon-s-flag flag-indigo"></i></div>
              <div v-if="order.Field6_1 == 6"><i class="el-icon-s-flag flag-purple"></i></div>
              <div><span>买家备注：</span><span>{{ order.Field6_2 || "无" }}</span></div>
              <div><span>卖家备注：</span><span>{{ order.Field6_3 || "无" }}</span></div>
              <div><el-button type="text" @click="editRemark(order)">修改</el-button></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="订单编号/店铺名称" min-width="200px">
          <template slot-scope="{row}">
            <div class="merge-item info-center" v-for="(order, key) in row.multiorder" :key="key"
              :id="'mall_' + order.id">
              <div>{{ order.orderNumber }}</div>
              <div>{{ order.mall.mallName }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="快递信息" min-width="200px">
          <div slot-scope="{row}" class="merge-item">
            <template v-if="row.logistics && row.logistics.length > 0">
              <div v-for="(i1, k1) in row.logistics" :key="k1">
                <div>{{ i1.name }}：</div>
                <div v-for="(i2, k2) in i1.noList" :key="k2">{{ i2 }}</div>
              </div>
              <div><el-button type="text">复制</el-button></div>
            </template>
            <span v-else>- -</span>
          </div>
        </el-table-column>
        <el-table-column label="单号状态" min-width="100px">
          <div slot-scope="{row}" class="merge-item">
            <div>
              <span v-if="row.Field9 == 0">- -</span>
              <span v-if="row.Field9 == 1">取号失败</span>
              <span v-if="row.Field9 == 2">正常</span>
              <span v-if="row.Field9 == 3">已回收</span>
              <span v-if="row.Field9 == 4">部分回收</span>
            </div>
            <div><el-button type="text" @click="showRecycle(row)">查看详情</el-button></div>
          </div>
        </el-table-column> -->
        <el-table-column prop="aliMallMallName" label="店铺名称" min-width="150px">
          <div slot-scope="{row}" class="merge-item">{{ row.aliMallMallName }}</div>
        </el-table-column>
        <el-table-column label="地址" min-width="300px">
          <div slot-scope="{row}" class="merge-item">
            <span>{{ row.province || '' }}{{ row.city || '' }}{{ row.district || '' }}{{ row.town || '' }}</span>
            <span>{{ row.address || '' }}</span>
          </div>
        </el-table-column>
        <!-- <el-table-column prop="province" label="省份" min-width="150px" show-overflow-tooltip>
          <div slot-scope="{row}" class="merge-item">{{ row.province }}</div>
        </el-table-column>
        <el-table-column prop="city" label="城市" min-width="150px" show-overflow-tooltip>
          <div slot-scope="{row}" class="merge-item">{{ row.city }}</div>
        </el-table-column>
        <el-table-column prop="district" label="区县" min-width="120px" show-overflow-tooltip>
          <div slot-scope="{row}" class="merge-item">{{ row.district }}</div>
        </el-table-column>
        <el-table-column prop="town" label="街道" min-width="120px" show-overflow-tooltip>
          <div slot-scope="{row}" class="merge-item">{{ row.town }}</div>
        </el-table-column>
        <el-table-column prop="address" label="收货地址" min-width="300px" show-overflow-tooltip>
          <div slot-scope="{row}" class="merge-item">{{ row.address }}</div>
        </el-table-column> -->
        <el-table-column prop="receiverName" label="收货人" min-width="80px">
          <div slot-scope="{row}" class="merge-item">{{ row.receiverName }}</div>
        </el-table-column>
        <el-table-column prop="receiverPhone" label="收货电话" min-width="110px">
          <div slot-scope="{row}" class="merge-item">{{ row.receiverPhone }}</div>
        </el-table-column>
        <el-table-column prop="buyer" label="下单人名称" min-width="100px">
          <div slot-scope="{row}" class="merge-item">{{ row.buyer }}</div>
        </el-table-column>
        <el-table-column label="备注/旗帜" min-width="400px">
          <template slot-scope="{row}">
            <div class="merge-item info-center" v-for="(order, key) in row.multiorder" :key="key"
              :id="'remark_' + order.id">
              <div v-if="order.flag"><i class="el-icon-s-flag" :class="order.flag"></i></div>
              <div><span>买家备注：</span><span>{{ order.buyerMemo || "无" }}</span></div>
              <div><span>卖家备注：</span><span>{{ order.remark || "无" }}</span></div>
              <div><el-button type="text" @click="editRemark(order)">修改</el-button></div>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="buyerMemo" label="下单备注" min-width="400px">
          <div slot-scope="{row}" class="merge-item">{{ row.buyerMemo }}</div>
        </el-table-column> -->
        <el-table-column prop="discountAmount" label="折扣金额" min-width="100px">
          <div slot-scope="{row}" class="merge-item">{{ row.discountAmount }}</div>
        </el-table-column>
        <el-table-column prop="expressName" label="物流公司名称" min-width="180px">
          <div slot-scope="{row}" class="merge-item">{{ row.expressName }}</div>
        </el-table-column>
        <el-table-column prop="logisticsId" label="物流ID" min-width="150px">
          <div slot-scope="{row}" class="merge-item">{{ row.logisticsId }}</div>
        </el-table-column>
        <el-table-column prop="expressNumber" label="物流单号" min-width="160px">
          <div slot-scope="{row}" class="merge-item">{{ row.expressNumber }}</div>
        </el-table-column>
        <el-table-column prop="lastShipTime" label="发货时间" min-width="160px">
          <div slot-scope="{row}" class="merge-item">{{ row.lastShipTime }}</div>
        </el-table-column>
        <el-table-column prop="goodsCount" label="商品数量" min-width="80px">
          <div slot-scope="{row}" class="merge-item">{{ row.goodsCount }}</div>
        </el-table-column>
        <el-table-column prop="goodsId" label="商品ID" min-width="130px">
          <div slot-scope="{row}" class="merge-item">{{ row.goodsId }}</div>
        </el-table-column>
        <el-table-column prop="goodsName" label="商品名称" min-width="260px">
          <div slot-scope="{row}" class="merge-item">
            <div><span>{{ row.goodsName }}</span></div>
            <div><el-button type="text" @click="editGoodsInfo(row)">修改</el-button></div>
          </div>
        </el-table-column>
        <el-table-column prop="categoryName" label="类目名称" min-width="130px">
          <div slot-scope="{row}" class="merge-item">{{ row.categoryName }}</div>
        </el-table-column>
        <el-table-column prop="goodsImageUrl" label="商品图片" min-width="110px" align="center">
          <div slot-scope="{row}" class="merge-item">
            <el-image style="width: 80px;height: 80px;" :src="row.goodsImageUrl"></el-image>
          </div>
        </el-table-column>
        <el-table-column prop="orderSn" label="订单编号" min-width="180px">
          <div slot-scope="{row}" class="merge-item">{{ row.orderSn }}</div>
        </el-table-column>
        <el-table-column prop="orderStatusDesc" label="交易状态" min-width="150px">
          <div slot-scope="{row}" class="merge-item">{{ row.orderStatusDesc }}</div>
        </el-table-column>
        <el-table-column prop="orderTime" label="订单时间" min-width="160px">
          <div slot-scope="{row}" class="merge-item">{{ row.orderTime }}</div>
        </el-table-column>
        <el-table-column prop="orderTime" label="订单金额" min-width="160px">
          <div slot-scope="{row}" class="merge-item">{{ row.totalAmount }}</div>
        </el-table-column>
        <!-- <el-table-column prop="payAmount" label="付款金额" min-width="100px">
          <div slot-scope="{row}" class="merge-item">{{ row.payAmount }}</div>
        </el-table-column> -->
        <el-table-column prop="payTime" label="支付时间" min-width="160px">
          <div slot-scope="{row}" class="merge-item">{{ row.payTime == '0001-01-01 00:00:00' ? '' : row.payTime }}</div>
        </el-table-column>
        <el-table-column prop="shippingAmount" label="运费" min-width="80px">
          <div slot-scope="{row}" class="merge-item">{{ row.shippingAmount }}</div>
        </el-table-column>
        <el-table-column prop="skuId" label="SkuID" min-width="140px">
          <div slot-scope="{row}" class="merge-item">{{ row.skuId }}</div>
        </el-table-column>
        <el-table-column prop="uid" label="下单用户ID" min-width="160px">
          <div slot-scope="{row}" class="merge-item">{{ row.uid }}</div>
        </el-table-column>
        <el-table-column prop="afterSalesCreateTime" label="售后创建时间" min-width="160px">
          <div slot-scope="{row}" class="merge-item">{{ row.afterSalesCreateTime }}</div>
        </el-table-column>
        <el-table-column prop="afterSalesStatus" label="售后状态" min-width="100px">
          <div slot-scope="{row}" class="merge-item">{{ row.afterSalesStatus }}</div>
        </el-table-column>
        <el-table-column prop="afterSaleReason" label="售后原因" min-width="300px" show-overflow-tooltip>
          <div slot-scope="{row}" class="merge-item">{{ row.afterSaleReason }}</div>
        </el-table-column>
        <el-table-column prop="refundFree" label="退款金额" min-width="80px">
          <div slot-scope="{row}" class="merge-item">{{ row.refundFree }}</div>
        </el-table-column>
        <el-table-column prop="refundFinishTime" label="售后结束时间" min-width="160px">
          <div slot-scope="{row}" class="merge-item">{{ row.refundFinishTime }}</div>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <el-dialog title="请选择同步日期" :visible.sync="showSync" width="460px">
      <el-form :model="syncForm">
        <el-form-item label="开始日期" label-width="80px">
          <el-date-picker v-model="syncForm.startTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
            :clearable="false" />
        </el-form-item>
        <el-form-item label="结束日期" label-width="80px">
          <el-date-picker v-model="syncForm.endTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
            :clearable="false" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSync = false">取 消</el-button>
        <el-button type="primary" @click="syncOrder">确 定</el-button>
      </span>
    </el-dialog>
    <test-dialog ref="testDialog" />
    <print-dialog ref="printDialog" @reload="reload" @send-success="onSendSuccess" />
    <express-sheet-dialog ref="expressSheetDialog" @close-saved="reload" />
    <remark-dialog ref="remarkDialog" @close-saved="reload" />
    <setting-dialog ref="settingDialog" @close-saved="reload" />
    <recycle-msg-dialog ref="recycleMsgDialog" @closed="reload" />
    <recycle-dialog ref="recycleDialog" />
    <modify-price-dialog ref="modifyPriceDialog" @close-saved="reload" />
    <edit-goods-info-dialog ref="editGoodsInfoDialog" @closed="reload" />
  </div>
</template>
<script>
import listMixin from "../mixins/list"; // 部分相同的逻辑使用代码混入
import countDown from "../common/countDown";
import testDialog from "./testDialog";
import printDialog from "./printDialog";
import expressSheetDialog from "./expressSheetDialog";
import modifyPriceDialog from "./modifyPriceDialog";
import editGoodsInfoDialog from "./editGoodsInfoDialog";
import "../styles/list.scss";

export default {
  mixins: [listMixin],
  components: {
    countDown, testDialog, printDialog, expressSheetDialog,
    modifyPriceDialog, editGoodsInfoDialog
  },
  data() {
    return {
      quickSearch: 0, // 0：未打印，1：已打印未发货，2：已锁定，3：全部
      totalOrder: 0,
      totalParcel: 0,
      countInfo: {
        noPrint: 0,
        isPrint: 0,
        isLock: 0
      },
      showSync: false,
      syncForm: {
        startTime: this.$commonJs.getDayAgo(),
        endTime: this.$commonJs.getToday(),
      },
    };
  },
  computed: {
    syncCount() {
      return this.$store.state.sys.orderSyncCount;
    },
    // 同步状态
    syncLoading() {
      return this.$store.state.sys.orderSyncLoading;
    },
    isDev() {
      return process.env.NODE_ENV == "development";
    },
  },
  mounted() { },
  methods: {    
    reload() {
      this.$refs.list.reload();
      this.getCountInfo();
    },
    getCountInfo() {
      this[this.sysType + "Api"].order.getCountInfo().then(res => {
        if (res) {
          this.countInfo.noPrint = res.noPrint;
          this.countInfo.isPrint = res.isPrint;
          this.countInfo.isLock = res.isLock;
        }
      })
    },
    onTest() {
      // this.$refs.testDialog.open();
      this.onSendSuccess(["3990238237927498520"]);
    },
    getDataFunc(params) {
      params = {
        ...params,
        OrderType: this.quickSearch,
        IsShipped: false,
        SnField: this.snField,
        SnType: this.snType,
        [this.params.fieldType]: this.params.fieldValue,
        [this.params.timeType + "Start"]: params.startDate,
        [this.params.timeType + "End"]: params.endDate,
        startDate: '',
        endDate: '',
        timeType: ''
      }
      params = this.$commonJs.obj.removeNullKey(params);
      return new Promise((resolve, reject) => {
        this[this.sysType + "Api"].order.getOrders(params, this.mallToken).then(res => {
          console.log("res.data", res.data);
          this.totalOrder = res.count;
          this.totalParcel = res.count;
          // res.data = res.data.filter(x => x.receiverAddress.fullName != "");
          // if (this.quickSearch != 3) {
          //   res.data = res.data.filter(x => x.Field5 == this.quickSearch);
          // }
          res.data = res.data.map(x => {
            var is_same = false;
            // var is_same = res.data.some(w => w.id != x.id && (
            //   w.receiverAddress.fullName == x.receiverAddress.fullName &&
            //   w.receiverAddress.mobilePhone == x.receiverAddress.mobilePhone &&
            //   w.receiverAddress.province == x.receiverAddress.province &&
            //   w.receiverAddress.city == x.receiverAddress.city &&
            //   w.receiverAddress.district == x.receiverAddress.district
            // ))

            var state = 0;
            var logistics = [];
            var multiorder = [{ ...x }];

            // if (x.id == 2) state = 1;
            // if (x.id == 3) {
            //   state = 2;
            //   // 单快递，多面单
            //   logistics = [
            //     { name: "圆通快递", noList: ["YT8962139805105", "YT8962139805100"] },
            //   ];
            // }
            // if (x.id == 4) {
            //   state = 3;
            //   // 一个单，多商品
            //   multiorder = [{ ...x, items: [...x.items, ...x.items] }];
            // }
            // if (x.id == 5) {
            //   // 合单
            //   multiorder = [{ ...x }, { ...x, id: 12 }];
            // }
            // if (x.id == 6) {
            //   // 多快递，多面单
            //   logistics = [
            //     { name: "圆通快递", noList: ["YT8962139805105", "YT8962139805100", "YT8962139805100", "YT8962139805100", "YT8962139805100", "YT8962139805100", "YT8962139805100"] },
            //     { name: "中通快递", noList: ["ZT8962139805105", "ZT8962139805105", "ZT8962139805105", "ZT8962139805105"] }
            //   ];
            //   // 合单，单商品与多商品
            //   multiorder = [
            //     { ...x, items: [...x.items, ...x.items] },
            //     { ...x, id: 22 },
            //     { ...x, id: 32, items: [...x.items, ...x.items, ...x.items] }
            //   ];
            // }
            // if (x.id == 7) {
            //   state = 2;
            //   // 单快递，单面单
            //   logistics = [
            //     { name: "中通快递", noList: ["ZT8962139805105"] }
            //   ];
            // }
            // if (x.id == 8) {
            //   state = 2;
            //   // 多快递，多面单
            //   logistics = [
            //     { name: "圆通快递", noList: ["YT8962139805105", "YT8962139805100"] },
            //     { name: "中通快递", noList: ["ZT8962139805105"] }
            //   ];
            // }
            return {
              ...x,
              state: state,
              multiorder: multiorder, // 合单
              logistics: logistics, // 快递信息
              same: is_same,
              decryptData: {
                fullName: "",
                mobilePhone: "",
                address: "",
              }
            }
          })
          resolve(res)
        }).catch(err => {
          resolve({ Code: 1, data: [] })
        })
      })
    },
    modifyOrderPrice(row) {
      console.log("modifyOrderPrice", row)
      this.$refs.modifyPriceDialog.openEdit(row);
    },
    editGoodsInfo(goods) {
      console.log("goods", goods)
      this.$refs.editGoodsInfoDialog.openEdit(goods);
    },
    openPrint(data = null) {
      console.log("open", data)
      let rows = [];
      if (data) {
        rows = [data];
      } else {
        rows = this.$refs.list.getCheckedRows();
        if (rows.length == 0) {
          this.$message.warning("请选择数据");
          return;
        }
        if (this.quickSearch == 3) {
          let isSame = rows.every(x => x.isPrint == rows[0].isPrint);
          if (!isSame) {
            this.$message.warning("请选择状态相同的订单");
            return;
          }
        }
      }
      if (rows[0].isLock) {
        this.$message.warning("已锁定订单，无法进行操作");
        return;
      }
      this.$refs.printDialog.open().then(that => {
        that.setData({ isPrint: rows[0].isPrint, autoSend: false, rows: rows });
      });
    },
    openPrintWithSend(data = null) {
      let rows = [];
      if (data) {
        rows = [data];
      } else {
        rows = this.$refs.list.getCheckedRows();
        if (rows.length == 0) {
          this.$message.warning("请选择数据");
          return;
        }
        let isSame = rows.every(x => x.isPrint == rows[0].isPrint);
        if (!isSame) {
          this.$message.warning("请选择状态相同的订单");
          return;
        }
      }

      if (rows[0].isLock) {
        this.$message.warning("已锁定订单，无法进行操作");
        return;
      }

      if (!rows[0].isPrint) {
        this.$refs.printDialog.open().then(that => {
          that.setData({ isPrint: rows[0].isPrint, autoSend: true, rows: rows });
        });
      } else {
        this.$confirm('是否发货？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          console.log("发货");
          var sendOrders = rows.map(x => {
            return {
              orderSn: x.orderSn,
              mailNo: x.expressNumber,
              cpCode: "YUNDA",
              logisticsCpName: "韵达"
            }
          });
          this[this.sysType + "Api"].order.send({ sendOrders }).then(res => {
            if (res && res.length > 0) {
              this.$message({
                type: "error",
                dangerouslyUseHTMLString: true,
                message: (res.map(x => { return '<div>' + x + '</div>' })).join('<br />'),
              })
            } else {
              this.$message.success("发货成功");
            }
          })
        }).catch(() => { });
      }
    },
    onSendSuccess(data) {
      console.log("data", data);
      var notify = this.$notify({
        title: '发货成功',
        message: '开始同步订单信息',
        type: 'success',
        position: 'top-left',
        offset: 64,
        duration: 0
      });
      this[this.sysType + "Api"].order.updateAfterSend({ orderSn: data }).then(res => {
        notify.close();
        if (res && res.length > 0) {
          this.$message({
            type: "error",
            dangerouslyUseHTMLString: true,
            message: (res.map(x => { return '<div>订单：' + x + '，同步信息失败</div>' })).join('<br />'),
          })
        } else {
          this.$message.success("订单信息同步成功");
          this.reload();
        }
      })
    },
    onSync() {
      this.showSync = true;
      // this.$confirm('是否确定进行数据同步操作？', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   // console.log("确定")
      //   this.syncOrder();
      // }).catch(() => {
      //   console.log("取消");
      // });
    },
    syncOrder() {
      // this.syncLoading = this.$loading({
      //   lock: true,
      //   text: "正在同步...",
      //   spinner: "el-icon-loading",
      //   customClass: "my_loading",
      //   background: "rgba(0, 0, 0, 0.3)",
      // });
      this.$store.dispatch('setOrderSyncCount', 0);
      this.$store.dispatch('setOrderSyncLoading', true);
      this[this.sysType + "Api"].order.sync(this.syncForm).then(res => {
        this.showSync = false;
        this.$store.dispatch('setIsSyncOrder', true);
        // this.isSyncOrder = true;
        this.getSyncState();
      }).catch(err => {
        // this.isSyncOrder = false;
        if (err.errorCode == 40001)
          this.$store.dispatch('setIsSyncOrder', true);
        else
          this.$store.dispatch('setIsSyncOrder', false);
        // this.syncLoading.close();
        this.$store.dispatch('setOrderSyncLoading', false);
      })
    },
    getSyncState() {
      // 0：空闲，无抓取任务
      // 1：正在抓取中
      // 2：抓取已完成，成功
      // 3：抓取已中止，失败
      var interval = setInterval(() => {
        this[this.sysType + "Api"].order.syncStatus().then(res => {
          this.$store.dispatch('setOrderSyncCount', res.count);
          if (res.syncStatus != 1) {
            clearInterval(interval);
            // this.isSyncOrder = false;
            this.$store.dispatch('setIsSyncOrder', false);
            // this.syncLoading.close();
            this.$store.dispatch('setOrderSyncLoading', false);
            if (res.syncStatus == 2) this.$message.success("抓取完成");
            if (res.syncStatus == 3) this.$message.error("抓取失败，已终止");
            this.relaod();
          }
        }).catch(err => {
          clearInterval(interval);
          // this.isSyncOrder = false;
          this.$store.dispatch('setIsSyncOrder', false);
          // this.syncLoading.close();
          this.$store.dispatch('setOrderSyncLoading', false);
        })
      }, 4000);
    },
    onTypeChange(e) {
      this.$refs.list.getData();
    },
    onUpdateExpressSheet(row) {
      console.log("更新面单", row);
      this.$refs.expressSheetDialog.openEdit(row);
    },
    onSplitOrder(order) {
      this.$confirm('确定不合并此订单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // console.log("确定")
        console.log("拆分", order)
      }).catch(() => {
        // console.log("取消");
      });
    },
    //订单导出
    exportOrders() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      var params = this.$commonJs.obj.removeNullKey(this.params);
      this[this.sysType + "Api"].order.getOrders(params).then(res => {
        if (res && res.data) {
          var list = res.data.map(x => {
            return {
              mallName: x.aliMallMallName,
              province: x.province + x.city + x.district + x.town + x.address,
              receiverName: x.receiverName,
              receiverPhone: x.receiverPhone,
              buyer: x.buyer,
              buyerMemo: x.buyerMemo,
              discountAmount: x.discountAmount,
              expressName: x.expressName,
              logisticsId: x.logisticsId,
              expressNumber: x.expressNumber,
              lastShipTime: x.lastShipTime,
              goodsCount: x.goodsCount,
              goodsId: x.goodsId,
              goodsName: x.goodsName,
              categoryName: x.categoryName,
              orderSn: x.orderSn,
              orderStatusDesc: x.orderStatusDesc,
              orderTime: x.orderTime,
              payAmount: x.payAmount,
              payTime: x.payTime,
              shippingAmount: x.shippingAmount,
              skuId: x.skuId,
              uid: x.uid,
              afterSalesCreateTime: x.afterSalesCreateTime,
              afterSalesStatus: x.afterSalesStatus,
              afterSaleReason: x.afterSaleReason,
              refundFree: x.refundFree,
              refundFinishTime: x.refundFinishTime,
            }
          });
          if (list.length > 0) {
            var item = list[0];
            var keys = Object.keys(item);

            import('@/vendor/Export2Excel').then(excel => {
              const tHeader = ['店铺名称', '地址', '收货人', '收货电话', '下单人名称', '下单备注', '折扣金额', '物流公司名称', '物流ID', '物流单号', '发货时间', '商品数量', '商品ID', '商品名称', '类目名称', '订单编号', '交易状态', '订单时间', '付款金额', '支付时间', '运费', 'SkuID', '下单用户ID', '售后创建时间', '售后状态', '售后原因', '退款金额', '售后结束时间'];
              const filterVal = keys;
              excel.export_json_to_excel({
                header: tHeader,
                data: this.formatJson(filterVal, list),
                filename: "导出待发货订单_" + this.$commonJs.toDateStringByFormat(new Date, "YYYYMMDDHHmmss"),
              })
              loading.close();
            })
          } else {
            this.$message.error("没有数据可以导出")
            loading.close();
          }
        } else {
          this.$message.error("获取数据失败")
          loading.close();
        }
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j])
        } else {
          return v[j]
        }
      }))
    },
    selectFlag(data) {
      return new Promise((resolve, reject) => {
        console.log("data", data);
        this[this.sysType + "Api"].order.saveFlag(data).then(res => {
          resolve(res)
        })
      })
    },
  },
};
</script>
<style lang="scss"></style>